import moment from 'moment';

import { Orchestration } from 'api/experimentResults';

// How a post-processing run is named in every select of runs: the case viewer's Orchestration ID filter and the
// Workflow exports, so a run picked in one is recognised in the other.
export const ORCHESTRATION_SELECT_LABEL = 'Orchestration ID';

export const getOrchestrationOptionText = ({
  orchestrationId,
  createdAtMinimum,
}: Pick<Orchestration, 'orchestrationId' | 'createdAtMinimum'>) =>
  `${orchestrationId}, Created at ${moment(createdAtMinimum).format('L LT')}`;
